import * as Yup from 'yup';

export const replyYopValidation = () => {
  return Yup.object().shape({
    reply: Yup.string().required('required'),
  });
};

export const playgroundYopValidation = () => {
  return Yup.object().shape({
    message: Yup.string().required('required'),
    fileText: Yup.string(),
    assistant: Yup.object()
      .test('has-either-value-or-label', 'required', (value) => value && (value.value || value.label))
      .required('required'),
  });
};
